import { Grid, Typography } from "@mui/material";
import React from "react";
import GuageCard from "../../../components/GuageCard";

function ReportPiewChart({ val, _ind }) {
  return (
    <Grid item key={_ind} xs={12}>
      <GuageCard data={val} />
    </Grid>
  );
}

export default ReportPiewChart;
